import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import useSheet from '../../../../../mobile/structural/sheet/hooks/useSheet';
import { useGroupTranslator } from '../../../../../components/i18n/GroupTranslationContext';

import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { getSelectedTaskIdSelector } from '../../../selector/selectionToolsSelector';
import { getTagById } from '../../../../../element/tags/tagsService';

import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';
import MobileTagsSheet from '../../../../../element/tags/MobileTagsSheet';
import MobileTagEditSheet from '../../../../../element/tags/MobileTagEditSheet';

import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { SheetId } from '../../../../../mobile/structural/sheet/sheetTypes';
import { TagsToolbarPopupProps } from './TagsToolbarPopup';
import { Tag } from '../../../../../../common/tags/tagTypes';
import { tagPathDisplaySelector } from '../../../../../element/tags/tagPathDisplaySelector';

type MobileTagsToolProps = TagsToolbarPopupProps & {
    selectedElements: Immutable.List<ImMNElement>;
    name: string;
};

const MobileTagsTool: React.FC<MobileTagsToolProps> = (props) => {
    const { selectedElements } = props;
    const translate = useGroupTranslator();
    const mobileName = translate('mobile.tags');
    const [currentlyEditingTag, setCurrentlyEditingTag] = useState<Tag | null>(null);
    const { shareRootPath } = useSelector(tagPathDisplaySelector);

    const elementIds = selectedElements.map(getElementId).toArray();
    const selectedTaskListId = useSelector(getSelectedTaskIdSelector);
    const focusElementIds = selectedTaskListId ? [selectedTaskListId] : elementIds;

    const tagsSheetProps = useSheet(SheetId.TagsTool, focusElementIds[0]);
    const {
        isSheetOpen: isTagsSheetOpen,
        dispatchOpenSheet: dispatchTagsOpenSheet,
        dispatchCloseSheet: dispatchTagsCloseSheet,
    } = tagsSheetProps;
    const tagEditSheetProps = useSheet(SheetId.TagEditTool, focusElementIds[0]);
    const { dispatchOpenSheet: dispatchOpenTagEditSheet, dispatchCloseSheet: dispatchCloseTagEditSheet } =
        tagEditSheetProps;

    const handleClickEdit = async (tagId: string) => {
        if (!tagId) return;

        const tag = await getTagById(tagId);
        if (!tag) return;

        setCurrentlyEditingTag(tag);
        dispatchOpenTagEditSheet();
    };

    return (
        <div className="MobileTagsTool">
            <ToolbarTool name={mobileName} isOpen={isTagsSheetOpen} onClick={dispatchTagsOpenSheet}>
                <Icon name={'toolbar-tag'} />
            </ToolbarTool>
            <MobileTagsSheet
                {...props}
                sheetProps={tagsSheetProps}
                rootPath={shareRootPath}
                closePopup={dispatchTagsCloseSheet}
                handleClickEdit={handleClickEdit}
            />
            <MobileTagEditSheet
                {...props}
                sheetProps={tagEditSheetProps}
                rootPath={shareRootPath}
                closePopup={dispatchCloseTagEditSheet}
                tag={currentlyEditingTag}
            />
        </div>
    );
};

export default MobileTagsTool;
